import React from 'react';
import { Col, Form } from 'react-bootstrap';
import { Selectize, FormNumber, FormRadio, FormSelect } from '~/components/FormControl';
import { useFormTab } from '~/pages/CardSaga/components/providers/FormTabProvider';
import isEmpty from 'lodash/isEmpty';

function BasicDetail() {
    const { cardMetaData } = useFormTab();
    const { prompts, conditions, effects, powers } = cardMetaData;

    return (
        <>
            {!isEmpty(cardMetaData) && (
                <>
                    <Form.Row>
                        <Selectize
                            as={Col}
                            sm="4"
                            name="basicDetail.startEffects"
                            options={[...effects, ...conditions, ...prompts] || []}
                            tooltip="Effects the card will have when activated."
                        />
                        <FormNumber
                            name="basicDetail.modifiedDv1Value"
                            isNegativeAllowed
                            tooltip="DV amount to change for the first DV changed effect, i.e increase or decrease DV."
                        />
                        <FormNumber
                            name="basicDetail.modifiedDv2Value"
                            isNegativeAllowed
                            tooltip="DV amount to change for the second DV changed effect, i.e increase or decrease DV."
                        />
                        <FormNumber
                            name="basicDetail.attackModifiedValue"
                            isNegativeAllowed
                            tooltip="Additional strike given to player. Ex: Set Damage Changed."
                        />
                        <FormNumber
                            name="basicDetail.defenseModifiedValue"
                            isNegativeAllowed
                            tooltip="Additional defense given to player. Ex: Set Defense Changed."
                        />
                        <FormNumber
                            name="basicDetail.fixedDvValue"
                            tooltip="DV amount given to player."
                        />
                        <FormNumber
                            name="basicDetail.maxDvValue"
                            tooltip="Maximum DV player eligible to have after effect. Ex: Set Max DV."
                        />
                        <FormNumber
                            name="basicDetail.damageValue"
                            tooltip="Damage inflicted to player. Ex: Do Fixed Damage Player."
                        />
                        <FormNumber
                            name="basicDetail.healedValue"
                            tooltip="HP amount that card offers to heal player.Ex: Heal Player HP."
                        />
                        <FormNumber
                            name="basicDetail.hpValue"
                            tooltip="HP amount set to player. Ex: Set Player HP."
                        />
                        <FormNumber
                            name="basicDetail.blockModifiedValue"
                            tooltip="Modified block value given for player after effect finishes. Ex: Reduce Block."
                        />
                        <Selectize
                            as={Col}
                            sm="4"
                            name="basicDetail.duelEffects"
                            options={[...effects, ...conditions] || []}
                            tooltip="Effects that will run only during duels."
                        />
                        <Selectize
                            as={Col}
                            sm="4"
                            name="basicDetail.afterDuelEffects"
                            options={[...effects, ...conditions, ...prompts] || []}
                            tooltip="List of card's after duel effects."
                        />
                        <FormNumber
                            name="basicDetail.numberOfCardsToMoveValue"
                            tooltip="Number of cards to move during a prompt, i.e moving cards from Discard pile to hand."
                            label="No. Of Cards To Move"
                        />
                        <FormNumber
                            name="basicDetail.hitValue"
                            tooltip="Number of times the player will attack. Ex: Double Tap."
                        />
                        <FormNumber
                            name="basicDetail.penaltyDvValue"
                            tooltip="Penalty DV incurred on player after effect. Ex: Overshield."
                        />
                        <FormNumber
                            name="basicDetail.pointToStealValue"
                            tooltip="Points to steal from opponent's player. Ex: Avarice."
                        />
                        <FormSelect
                            name="basicDetail.powerToRefresh"
                            options={[...powers] || []}
                            sm={4}
                            tooltip="List of powers to refresh for player. Ex: Restore."
                        />
                        <FormRadio
                            name="basicDetail.hasFirstStrike"
                            tooltip="Whether to activate 'First Strike' for player. Ex: Long Strike."
                        />
                        <FormNumber
                            name="basicDetail.firstStrikeMultiHitValue"
                            tooltip="The number of times player will attack with 'First Strike'."
                            label="First Strike Multi Hit"
                        />
                        <Selectize
                            as={Col}
                            sm="4"
                            name="basicDetail.onRevealEffects"
                            options={[...effects, ...conditions, ...prompts] || []}
                            tooltip="To list effects the card will have when activated."
                        />
                        <FormNumber
                            name="basicDetail.effectPriorityValue"
                            tooltip="To give the card special priority activation during a duel (-1 slower, 1 higher )."
                        />
                        <FormNumber
                            name="basicDetail.fixedStrikeValue"
                            tooltip="To set a fixed value of strikes for the player."
                        />
                        <FormNumber
                            name="basicDetail.fixedBlockValue"
                            tooltip="To set a fixed value of blocks for the player."
                        />
                    </Form.Row>
                    <Form.Row>
                        <FormNumber
                            name="basicDetail.persistentDvValue"
                            tooltip="To set persistent DV value for player."
                            sm={2}
                        />
                        <FormNumber
                            name="basicDetail.persistentStrikeValue"
                            tooltip="To set persistent strike value for player."
                            sm={2}
                        />
                        <FormNumber
                            name="basicDetail.persistentBlockValue"
                            tooltip="To set persistent block value for player."
                            sm={2}
                        />
                        <FormNumber
                            name="basicDetail.opponentPersistentDvValue"
                            tooltip="To set persistent DV value for opponent."
                            sm={2}
                            label="Opp. persistent DV value"
                        />
                        <FormNumber
                            name="basicDetail.opponentPersistentStrikeValue"
                            tooltip="To set persistent strike value for opponent."
                            sm={2}
                            label="Opp. persistent strike value"
                        />
                        <FormNumber
                            name="basicDetail.opponentPersistentBlockValue"
                            tooltip="To set persistent block value for opponent."
                            sm={2}
                            label="Opp. persistent block value"
                        />
                    </Form.Row>
                </>
            )}
        </>
    );
}

export default BasicDetail;
